"use client";

import { useEffect } from "react";

/** Einheitliche Sicherheitsabfrage für sämtliche Löschbuttons der Anwendung. */
export function DeleteConfirmationGuard() {
  useEffect(() => {
    const lockSollQuantities = () => document.querySelectorAll<HTMLInputElement>(".controlling-material-overview input[name='quantity']").forEach((input) => {
      input.readOnly = true;
      input.setAttribute("aria-readonly", "true");
    });
    const formatActualCosts = () => document.querySelectorAll<HTMLInputElement>(".controlling-material-overview input[name='actualUnitCost']").forEach((input) => {
      if (input.dataset.ekFormatted || !input.value.trim()) return;
      const value = Number(input.value.replace(",", "."));
      if (Number.isFinite(value)) {
        // Text erlaubt die gewünschte deutsche Darstellung „25,00“.
        input.type = "text";
        input.inputMode = "decimal";
        input.value = value.toFixed(2).replace(".", ",");
      }
      input.dataset.ekFormatted = "true";
    });
    const markFlatRateRows = () => document.querySelectorAll<HTMLTableRowElement>(".controlling-material-overview tbody tr").forEach((row) => {
      if (row.cells[1]?.textContent?.includes("Pauschale")) row.classList.add("is-pauschale-row");
    });
    lockSollQuantities();
    markFlatRateRows();
    formatActualCosts();
    const observer = new MutationObserver(() => { lockSollQuantities(); markFlatRateRows(); formatActualCosts(); });
    observer.observe(document.body, { childList: true, subtree: true });
    const handleSubmit = (event: SubmitEvent) => {
      const submitter = event.submitter;
      if (!(submitter instanceof HTMLElement) || !submitter.classList.contains("button-danger")) return;
      if (!window.confirm("Diesen Eintrag wirklich löschen? Dieser Vorgang kann nicht rückgängig gemacht werden.")) {
        event.preventDefault();
      }
    };
    document.addEventListener("submit", handleSubmit, true);
    return () => {
      observer.disconnect();
      document.removeEventListener("submit", handleSubmit, true);
    };
  }, []);
  return null;
}
